import { delegateInit } from './BaseShape';
import { ConditionRhombus } from './ConditionRhombus';

const ENTITY_FIELD_NAME = 'SwitchStatement';

export default delegateInit(ConditionRhombus, ENTITY_FIELD_NAME);
